var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_276_5069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6616 4.38137C16.5655 4.0197 16.3761 3.68962 16.1123 3.42417C15.8486 3.15871 15.5197 2.96718 15.1587 2.86875C13.8296 2.51137 8.51709 2.51137 8.51709 2.51137C8.51709 2.51137 3.20459 2.51137 1.8755 2.86875C1.51446 2.96718 1.1856 3.15871 0.921835 3.42417C0.658072 3.68962 0.468656 4.0197 0.372544 4.38137C0.0170899 5.71625 0.0170898 8.5 0.0170898 8.5C0.0170898 8.5 0.0170899 11.2838 0.372544 12.6186C0.468656 12.9803 0.658072 13.3104 0.921835 13.5758C1.1856 13.8413 1.51446 14.0328 1.8755 14.1313C3.20459 14.4886 8.51709 14.4886 8.51709 14.4886C8.51709 14.4886 13.8296 14.4886 15.1587 14.1313C15.5197 14.0328 15.8486 13.8413 16.1123 13.5758C16.3761 13.3104 16.5655 12.9803 16.6616 12.6186C17.0171 11.2838 17.0171 8.5 17.0171 8.5C17.0171 8.5 17.0171 5.71625 16.6616 4.38137Z",
    fill: "#FF0302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77832 11.0278V5.97224L11.2215 8.50003L6.77832 11.0278Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_276_5069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.5676440d169cc46843bf5017b08a3704.svg";
export { ForwardRef as ReactComponent };